import { z } from 'zod';
import { isIsoDay } from '../utils/checklist.js';
import { PLAN_START_TIME_PATTERN } from '../types/floor-plan.js';
import { VENDOR_FOLDER_NODE_PATTERN } from '../utils/vendorPortal.js';
const timeOfDay = z
    .string()
    .regex(PLAN_START_TIME_PATTERN, 'A time of day, HH:MM on the 24-hour clock')
    .nullable();
const isoDay = z.string().refine(isIsoDay, 'Not a valid date').nullable();
/**
 * A booking's metadata — the EVENT→VENDOR link's `metadata` — typed.
 *
 * Every key is optional, since a patch changes one at a time
 * (`metadataPatch`), and every value but the grants may be null, which clears
 * it. Strict: a key nobody reads is refused rather than stored, since the
 * column is written by more than one screen and a misspelt key is a setting
 * that silently does nothing.
 */
export const eventVendorMetadataSchema = z
    .object({
    stage: z.string().trim().min(1).max(100).nullable(),
    arrivalTime: timeOfDay,
    loadInTime: timeOfDay,
    dayOfContactUserId: z.string().uuid().nullable(),
    contractSignedAt: isoDay,
    coiExpiresAt: isoDay,
    contractExpiresAt: isoDay,
    description: z.string().max(2000).nullable(),
    canMessage: z.boolean(),
    canMessageClients: z.boolean(),
    // The vendor portal (`utils/vendorPortal.ts`). A list is written whole.
    portalExpenses: z.boolean(),
    portalTimeline: z.boolean(),
    portalItems: z.boolean(),
    portalAddTasks: z.boolean(),
    portalFolders: z
        .array(z
        .object({
        nodeId: z
            .string()
            .regex(VENDOR_FOLDER_NODE_PATTERN, 'An event or a folder of its files'),
        access: z.enum(['read', 'upload']),
    })
        .strict())
        .max(50),
    portalFloorPlans: z
        .array(z.object({ floorPlanId: z.string().uuid(), guestNames: z.boolean() }).strict())
        .max(50),
})
    .partial()
    .strict();
/** `PATCH /vendors/:id/contacts/:userId` — a contact's role, making them the primary, or CC on emails. */
export const updateVendorContactSchema = z
    .object({
    role: z.string().trim().max(100).nullable(),
    isPrimary: z.boolean(),
    ccOnEmails: z.boolean(),
})
    .partial()
    .refine((body) => Object.values(body).some((value) => value !== undefined), {
    message: 'Nothing to change.',
});
//# sourceMappingURL=booking.js.map